/**
 * 生成中・解決中の待機表示
 *
 * 画面を離れてもジョブは動き続けるので、その旨を伝える。
 */

import { Loader2 } from 'lucide-react'

type Props = {
  title: string
  description: string
  done?: number
  total?: number
}

export const ImportProgress = ({ title, description, done, total }: Props) => {
  const hasBar = typeof done === 'number' && typeof total === 'number' && total > 0
  const percent = hasBar ? Math.round((done / total) * 100) : 0

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center">
      <Loader2 className="size-8 animate-spin text-muted-foreground" />
      <div className="space-y-1">
        <p className="font-medium">{title}</p>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>

      {hasBar && (
        <div className="w-full max-w-xs space-y-2">
          <div className="h-2 w-full overflow-hidden rounded-full bg-primary/15">
            <div className="h-full bg-primary transition-all" style={{ width: `${percent}%` }} />
          </div>
          <p className="text-sm tabular-nums text-muted-foreground">
            {done} / {total}
          </p>
        </div>
      )}

      <p className="text-xs text-muted-foreground">この画面を閉じても処理は続きます。</p>
    </div>
  )
}
